import React from 'react';
import PropTypes from 'prop-types';
import NewJerseyHome from './new-jersey-home';
import NewYorkHome from './new-york-home';

const AddressHome = ({ location }) => {
  switch (location) {
    case 'new_jersey':
      return <NewJerseyHome />;
      break;
    case 'new_york':
      return <NewYorkHome />;
      break;
    default:
      break;
  }
};

AddressHome.propTypes = {
  location: PropTypes.string,
};

export default AddressHome;



// WEBPACK FOOTER //
// ./src/components/address-home/index.js